import { render, staticRenderFns } from "./PersonBox.vue?vue&type=template&id=d76247a4&scoped=true"
import script from "./PersonBox.vue?vue&type=script&lang=js"
export * from "./PersonBox.vue?vue&type=script&lang=js"
import style0 from "./PersonBox.vue?vue&type=style&index=0&id=d76247a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76247a4",
  null
  
)

export default component.exports